import React from 'react';


function ContactButton() {  
  return (
    <a className='btn btn-primary' href='#contact'>Contact Me</a>
  )
}

export default ContactButton;